import {createFileRoute} from '@tanstack/react-router';

import TeamClubManageView from '../../../../clubs/TeamClubManageView.tsx';

export const Route = createFileRoute('/_app/clubs/$club_uid/manage')({
    component: RouteComponent,
});

function RouteComponent() {
    return <TeamClubManageView />;
}
